const getCurrentMenu = ({
  currentMousePosition,
  submenuRect,
  submenuTriggerRect
}) => {
  const {
    x,
    y
  } = currentMousePosition;
  if (x >= submenuTriggerRect.left && x <= submenuTriggerRect.right && y >= submenuTriggerRect.top && y <= submenuTriggerRect.bottom) {
    return submenuTriggerRect;
  }
  return submenuRect;
};
export default getCurrentMenu;